import React from 'react';
import { SelectableColors } from '@/types/content';
import { escapeHtmlAttribute } from '@/lib/utils';

interface HeadingProps {
  level: '1' | '2' | '3' | '4' | '5' | '6';
  title?: string;
  color?: SelectableColors;
  bold?: boolean;
  showInTrackingPanel?: boolean;
  attributes?: React.HTMLProps<HTMLDivElement>;
}

export const Heading = ({ 
  level,
  title,
  color,
  bold,
  showInTrackingPanel = true,
  attributes 
}: HeadingProps) => {
  const colorClass = 
    color === "brand" ? "text-brand" : 
    color === "primary" ? "text-foreground" : 
    color === "secondary" ? "text-muted-foreground" : 
    "text-foreground";
  const boldClass = bold ? "font-bold" : "font-normal";
  const { key, ...rest } = attributes ?? {};
  const headingClass = `heading-${level}`;
  const headingId = `heading-${key}`;
  const normalizedTitle = title
    ?.toLowerCase()
    .trim()
    .replace(/[^\w\- ]+/g, "")
    .replace(/\s+/g, "-");

  
  return (
    <div
      key={key}
      {...rest}
      className="content-heading"
    >
      <div 
        data-trackable={showInTrackingPanel} 
        data-trackable-title={normalizedTitle}
        data-text-title={escapeHtmlAttribute(title)}
        id={headingId} 
        className={`${colorClass} ${boldClass} ${headingClass}`}
      >
        {title ?? ''}
      </div>
    </div>
  );
}; 